export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_4W_38_95_4W_12_15',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_38_95_4w_12_15_usd',
			EUR: 'simple_premium_4w_38_95_4w_12_15_eur',
			GBP: 'simple_premium_4w_38_95_4w_12_15_gbp',
			AUD: 'simple_premium_4w_59_99_4w_15_99_aud',
			CAD: 'simple_premium_4w_49_99_4w_15_99_cad',
			DKK: 'simple_premium_4w_259_4w_79_99_dkk',
			SEK: 'simple_premium_4w_369_4w_111_99_sek',
			NOK: 'simple_premium_4w_389_4w_119_2_nok',
			BRL: 'simple_premium_4w_219_4w_68_79_brl',
			MXN: 'simple_premium_4w_749_4w_231_2_mxn',
			TRY: 'simple_premium_4w_1519_4w_471_2_try',
			ARS: 'simple_premium_4w_51890_4w_16232_ars',
			COP: 'simple_premium_4w_157390_4w_49352_cop',
			CLP: 'simple_premium_4w_37690_4w_11832_clp',
		},
		primer: 'prd_JOK6gDKRoDwN',
	},
}
